var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperIconcircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 192.104,
    height: 192.104,
    viewBox: "0 0 192.104 192.104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_8126",
    x: 0,
    y: 0,
    width: 192.104,
    height: 192.104,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.333
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Paper-icon_circle",
    "data-name": "Paper-icon + circle",
    transform: "translate(-1075 -614)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203",
    transform: "translate(1105 644)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -30, -30)",
    filter: "url(#Path_8126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8126-2",
    "data-name": "Path 8126",
    d: "M66.052,0A66.052,66.052,0,1,1,0,66.052,66.052,66.052,0,0,1,66.052,0Z",
    transform: "translate(30 30)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_09938f3c30b23413c5a4e57ca0dc2442",
    "data-name": "09938f3c30b23413c5a4e57ca0dc2442",
    transform: "translate(38.345 31.346)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8113",
    "data-name": "Path 8113",
    d: "M64.366,71.852H23.654A5.671,5.671,0,0,1,18,66.2V9.654A5.671,5.671,0,0,1,23.654,4h29.4L70.02,20.963V66.2A5.671,5.671,0,0,1,64.366,71.852Z",
    transform: "translate(-16.304 -2.304)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8114",
    "data-name": "Path 8114",
    d: "M65.314,74.393H42.7A1.7,1.7,0,0,1,42.7,71H65.314a1.7,1.7,0,1,1,0,3.393Zm0,9.047H42.7a1.7,1.7,0,0,1,0-3.393H65.314a1.7,1.7,0,1,1,0,3.393Z",
    transform: "translate(-26.299 -31.42)",
    fill: "#1f7672"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8115",
    "data-name": "Path 8115",
    d: "M80,4V15.309a5.671,5.671,0,0,0,5.654,5.654H96.963Z",
    transform: "translate(-43.247 -2.304)",
    fill: "#dfeae2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8116",
    "data-name": "Path 8116",
    d: "M70.413,19.659a1.627,1.627,0,0,0-.509-1.187L52.941,1.509a1.657,1.657,0,0,0-1.809-.4A1.7,1.7,0,0,0,50.057,2.7V14.005a7.336,7.336,0,0,0,7.351,7.351H67.02V64.894a3.934,3.934,0,0,1-3.958,3.958H22.351a3.934,3.934,0,0,1-3.958-3.958V8.351a3.934,3.934,0,0,1,3.958-3.958H40.445a1.666,1.666,0,0,0,1.7-1.7,1.666,1.666,0,0,0-1.7-1.7H22.351A7.336,7.336,0,0,0,15,8.351V64.894a7.336,7.336,0,0,0,7.351,7.351H63.062a7.336,7.336,0,0,0,7.351-7.351V19.659Zm-13.005-1.7a3.934,3.934,0,0,1-3.958-3.958V6.767l11.2,11.2Z",
    transform: "translate(-15 -1)",
    fill: "#415779"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_8b54aaaebaa880ff783758c238b5079c",
    "data-name": "8b54aaaebaa880ff783758c238b5079c",
    d: "M23.367,10.169a1.279,1.279,0,0,1,.389.949A1.405,1.405,0,0,1,22.5,12.436a3.345,3.345,0,0,0-1.86,1,2.413,2.413,0,0,0-.583,1.587,3.136,3.136,0,0,1,2.423,2.832v.064a2.783,2.783,0,0,1-.87,2.069,3.289,3.289,0,0,1-2.288.829,3.144,3.144,0,0,1-2.491-1.068,4.239,4.239,0,0,1-.874-2.791v-.128a7.107,7.107,0,0,1,2.124-5.449A6.364,6.364,0,0,1,22.154,9.76,1.712,1.712,0,0,1,23.367,10.169Zm-3.6,5.054a2.919,2.919,0,0,1,2.42,2.63v.064a2.63,2.63,0,0,1-2.81,2.63,2.63,2.63,0,0,0,2.808-2.63v-.064a2.919,2.919,0,0,0-2.42-2.63c-.069-1.54.9-2.662,2.662-3.047.588-.128,1.037-.481,1.037-1.058s-.38-1.091-1.314-1.091h0c.933,0,1.314.513,1.314,1.091s-.449.93-1.037,1.058C20.668,12.561,19.7,13.684,19.769,15.223Zm-5.183-5.054a1.279,1.279,0,0,1,.389.949,1.405,1.405,0,0,1-1.259,1.319,3.346,3.346,0,0,0-1.86,1,2.412,2.412,0,0,0-.583,1.587A3.136,3.136,0,0,1,13.7,17.853v.064a2.783,2.783,0,0,1-.87,2.069,3.289,3.289,0,0,1-2.288.829,3.144,3.144,0,0,1-2.491-1.068,4.239,4.239,0,0,1-.874-2.791v-.128A7.106,7.106,0,0,1,9.3,11.378,6.364,6.364,0,0,1,13.373,9.76,1.713,1.713,0,0,1,14.586,10.169Zm-3.6,5.054a2.92,2.92,0,0,1,2.42,2.63v.064a2.63,2.63,0,0,1-2.81,2.63,2.63,2.63,0,0,0,2.808-2.63v-.064a2.92,2.92,0,0,0-2.42-2.63c-.069-1.54.9-2.662,2.662-3.047.588-.128,1.037-.481,1.037-1.058s-.38-1.091-1.314-1.091h0c.933,0,1.314.513,1.314,1.091s-.449.93-1.037,1.058C11.886,12.561,10.918,13.684,10.988,15.223Z",
    transform: "translate(7.014 12.666)",
    fill: "#1f7672",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperIconcircle);
export default __webpack_public_path__ + "static/media/Paper-icon + circle.7197fadde72f429cff489d349f3ec9e4.svg";
export { ForwardRef as ReactComponent };